import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

//---------------------spent-fund------------------------------
export const spentFundApi = async (data) => {
  const endPoint =
    `/fund/list` + `?` + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

//--------------------received-fund-------------------------------
// export const receivedFundApi = async (data) => {
//     const endPoint = `/received/fund` + '?' + new URLSearchParams({ ...data }).toString()
//     return await axios.get(endPoint, setJwtToken())
// }

// //--------------------add-hash-fund-------------------------------
// export const requestFundApi = async (data) => {
//     const endPoint = `/request/fund` + '?' + new URLSearchParams({ ...data }).toString()
//     return await axios.get(endPoint, setJwtToken())
// }
// //--------------------decline-request----Paid-to-resource-------------------------------
export const fundRequestActionApi = async (data) => {
  const endPoint = `/resource/cancel_aid`;
  return await axios.put(endPoint, data, setJwtToken());
};
